import * as ActionTypes from '../actionTypes';

export const getWalletSummary = value => ({
  type: ActionTypes.GET_WALLET_SUMMARY,
  value
});

export const getWalletSummarySuccess = value => ({
  type: ActionTypes.GET_WALLET_SUMMARY_SUCCESS,
  value
});

export const getWalletSummaryFailure = value => ({
  type: ActionTypes.GET_WALLET_SUMMARY_FAILURE,
  value
});

export const getWalletTransactions = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS,
  value
});

export const getWalletTransactionsSuccess = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS_SUCCESS,
  value
});

export const getWalletTransactionsFailure = value => ({
  type: ActionTypes.GET_WALLET_TRANSACTIONS_FAILURE,
  value
});
